"use strict";

var _toConsumableArray = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWaveformSamples = void 0;

var filterData = function filterData(audioBuffer, samples) {
  var blockSize = Math.floor(audioBuffer.length / samples); // the number of samples in each subdivision

  if (blockSize === 0) {
    return [];
  }

  var filteredData = [];

  for (var i = 0; i < samples; i++) {
    var blockStart = blockSize * i; // the location of the first sample in the block

    var sum = 0;

    for (var j = 0; j < blockSize; j++) {
      sum += Math.abs(audioBuffer[blockStart + j]); // find the sum of all the samples in the block
    }

    filteredData.push(sum / blockSize); // divide the sum by the block size to get the average
  }

  return filteredData;
};

var normalizeData = function normalizeData(filteredData) {
  var multiplier = Math.pow(Math.max.apply(Math, _toConsumableArray(filteredData)), -1);
  return filteredData.map(function (n) {
    return n * multiplier;
  });
};

var getWaveformSamples = function getWaveformSamples(waveform, sampleAmount) {
  return normalizeData(filterData(waveform, sampleAmount));
};

exports.getWaveformSamples = getWaveformSamples;